import { render, staticRenderFns } from "./comprehensivequery.vue?vue&type=template&id=4335c986&scoped=true"
import script from "./comprehensivequery.vue?vue&type=script&lang=js"
export * from "./comprehensivequery.vue?vue&type=script&lang=js"
import style0 from "./comprehensivequery.vue?vue&type=style&index=0&id=4335c986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4335c986",
  null
  
)

export default component.exports